module.exports = __webpack_public_path__ + "img/interface OneB Player_4 prew.2284562b.jpg";